<!-- PEDIDO DE VENDA

FALTA:
- codigo do item deve retornar objeto ITEM completo do servidor e agregar ao PEDVIT
- campo unidade de medida listar somente o que está relacionado ao item
- carregar a tabela de preços como parametro para a pesquisa dos itens
- se o item nao possuir preco, habilitar campo de preco para digitacao


-->

<script>

import Trap from 'vue-focus-lock'
import { SysVars } from '../main';
import { arr, calcDesconto } from '../shared/numbers'
import { getText, formatValue } from '../shared/utils'
import { apiORDS, apiORDSpost, apiDownloadPDF, apiEmailPDF } from '../shared/api-functions'
import PedidoAddlist from './pedido-addlist'
import PedidoAdditem from './pedido-additem'
import PedidoTitulos from './pedido-titulos'
import PedidoFormInfcpl from './pedido-form-infcpl'
import PedidoImpressao from '../forms/pedido-impressao.vue'
import CustomerForm from './customer-form'
import NatesForm from './nates-form'
import CustomerContatoForm from './customer-contato-form'
import VendForm from './vend-form'
import grade from '../components/grade'
import AnexosForm from '../components/anexos-form'
import EstoqueSaida from '../forms-estoque/estoque-saida'
import Tourguide from 'tourguidejs';
import autorizaNFe from "../api/api-nfe.js";
import apiPedido from "../api/api-pedido.js";

export default {
  props: {
    index: '',
    crud: ''
  },

  components: {
    Trap, PedidoAdditem, PedidoTitulos, PedidoAddlist, PedidoFormInfcpl, CustomerForm,
    NatesForm, CustomerContatoForm, grade, AnexosForm, EstoqueSaida, PedidoImpressao, Tourguide
  },

  mixins: [apiPedido, autorizaNFe],

  data() {
    return {
      crudText: '',

      view: false, //variavel para controle de visualizacao ou edicao
      formNew: false, //incluindo novo pedido
      showFormInfAd: false, //editando cabecalho
      formPar: false, //editando parcelas
      formOrder: false,
      showFormItem: false, //exibe o formulario de manutencao de item
      showPartForm: false, //exibe o formulario de cliente para inclusao
      showVendForm: false, //exibe o formulario de vendedor para inclusao
      showNatesForm: false, //exibe o formulario de naturezas para inclusao
      showContatoForm: false, //exibe o formulario de contato do cliente para inclusao
      showFormEmail: false, //exibe o formulario para envio de email
      showTotal: false,
      btEnviar: false,
      btImprimir: false,
      btFaturar: false,
      btCancelar: false,
      formItemView: false,
      CANCEL_ITEM_MESSAGE: false,
      DELETE_ITEM_MESSAGE: false,
      CANCEL_MESSAGE: false,

      showListaDestaques: false,

      isValidCabec: true,

      updateItem: false, //indica quando for uma alteracao de item

      hasPriceTab: false,  //indica que possui tabela de preço e o campo preço será desabilitado

      //entidades
      pedv: { ...this.$store.getters.getEntities.pedv },
      pedvit: [],
      pedvpar: [],  //parcelas do pedido
      pedvit_update: {},
      metadata: this.$store.getters.getEntities.metadata,
      errmessages: {},  //armazena as mensagens de validacao do pedido de venda apos a gravacao

      anexos: [], //lista de anexos do pedido
      showAnexo: false,

      itped: 0, //sequencial do item
      moreActions: [],  //botao mais acoes

      unwatch: true,

      partTabela: false,
      partCodTabpre: null,

      showFormAlocacao: false,
      controleEstoqueAtivado: false,
      excluirAlocacao: false,

      local_metadata: {
        "fieldname": "tppedv",
        "label": "Tipo de Documento",
        "length": 1, "decimals": 0, "pk": "False", "options":
          [
            { "id": "O", "text": "Orçamento" },
            { "id": "P", "text": "Pedido de Venda" }]
      },

      codpedvImpressao: null,
      showImpressao: null,

      hasManyPedidos: false,
      steps: [
        {
          "selector": "",
          "step": 1,
          "title": `Vamos começar!`,
          "content": "Vamos te guiar passo a passo por todo o processo de lançamento de pedido.</br></br><a href='javascript:void(0)' class='btn btn-sm btn-danger text-white' onclick='window.dispatchEvent(new CustomEvent(\"desativar-guia\"))'>Não mostrar este guia</a>",
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          "selector": "#part",
          "step": 2,
          "title": `Cliente`,
          "content": "Informe o cliente do pedido.",
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          "selector": "#codnates",
          "step": 3,
          "title": `Natureza de Operação`,
          "content": "Informe a natureza de operação do pedido.",
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          "selector": "#produtos",
          "step": 4,
          "title": `Produtos`,
          "content": "Adicione os itens ao pedido.",
          // "image": "https://somehost.com/image.jpeg"
        },




      ],


    }
  },

  computed: {

    orcamentoVencido: function () {
      return (this.pedv.tppedv == 'O' && this.pedv.stpedv == 'P' && this.pedv.dtvalidade && (new Date(this.pedv.dtvalidade).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)))
    },

    alocacaoEfetuada: function () {
      if (this.pedv.alocado == 'S')
        return 'Pedido com estoque alocado. Para efetuar alterações será necessário excluir a alocação.'
      else
        return null
    },

    alocacaoPendente: function () {
      if (this.controleEstoqueAtivado && this.pedv.tppedv == 'P' && this.pedv.movest == 'S' && this.pedv.alocado != 'S')
        return 'Efetue a alocação do estoque dos produtos. O pedido não poderá ser alterado após a alocação.'
      else
        return null
    },

    botaoAlocarProdutos: function () {
      return this.controleEstoqueAtivado && this.pedv.tppedv == 'P' && this.pedv.movest == 'S' && this.pedv.alocado != 'S'
    },

    botaoGerarPedido: function () {
      return this.pedv.tppedv == 'O' && !this.pedv.codnegocio && !this.bloqueia_gerar_pedido
    },

    botaoPerdido: function () {
      return this.pedv.tppedv == 'O' && !this.pedv.codnegocio
    },

    possuiListaDestaqueValida: function () {
      if (!this.$store.getters.getDestaqList.length)
        return false
      else {
        return this.$store.getters.getDestaqList.filter(obj => { return obj.isvalid == 'S' }).length > 0
      }
    },

    showPesquisaItens: function () {
      return !this.isView && this.pedv.codpart && this.pedv.codnates && !this.showFormItem
    },

    showTitulosPedido: function () {
      return this.crud != SysVars.crudI && this.pedv.stpedv == 'P' && this.pedv.fin && this.pedv.fin.length > 0
    },

    select2Contato: function () {
      return { entity: 'partcontato/' + this.pedv.codpart, minlength: 0 }
    },

    isView: function () {
      //NAO PERMITE ALTERACAO NO PEDIDO QUANDO HÁ TITULOS ENVIADOS, TITULOS BAIXADOS OU NOTA LANÇADA
      return this.view || this.pedv.alocado == 'S' || this.pedv.tppedv == 'R' ||
        (this.pedv.stpedv != 'D' && this.pedv.stpedv != 'P') ||
        (this.pedv.fin_baixado > 0) ||
        (this.pedv.fin_remessa > 0) ||
        (this.pedv.nf_emitida > 0) ||
        (this.pedv.nf_pendente > 0)
    },

    btTotalizar: function () {
      return this.pedv.stpedv == 'D' && this.pedvit && this.pedvit.length > 0
    },

    bloqueia_gerar_pedido: function () {
      if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas)
        return this.$store.getters.getParametrosUsuario.vendas.bloqueia_gerar_pedido
      else
        return false
    },

    tabelas_preco_options: function () {
      //monta objeto de tabelas de preco conforme permissao do usuario (usuario.parametros.vendas.tabelaspreco)
      let options = []

      let liberado = []
      let currTabpre = {}
      let addTabela = false

      for (var x = 0; x < this.$store.getters.getTabpreList.length; x++) {
        currTabpre = this.$store.getters.getTabpreList[x]

        //se existir parametros do usuario, libera somente as tabelas permitidas
        if (this.partCodTabpre && this.partCodTabpre == currTabpre.codtabpre)
          addTabela = true
        else
          if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas && this.$store.getters.getParametrosUsuario.vendas.tabelaspreco && this.$store.getters.getParametrosUsuario.vendas.tabelaspreco.length > 0) {
            liberado = this.$store.getters.getParametrosUsuario.vendas.tabelaspreco.filter((obj) => { return obj == currTabpre.codtabpre })
            if (liberado.length > 0) {
              addTabela = true
            }
          } else {
            addTabela = true
          }

        if (addTabela)
          options.push({ id: currTabpre.codtabpre, text: currTabpre.descricao })

        addTabela = false
      }

      return options
    },

    status_customizados_options: function () {
      //monta objeto de status atraves do cadastro de status
      if (!this.$store.getters.getPdstatusList.length) {
        return []
      }
      let options = this.$store.getters.getPdstatusList.map(function (obj) {
        return { id: obj.codstatus, text: obj.descricao }
      })
      return options
    },

    itemList: function () {
      return this.$store.getters.getItemSalesList
    },

    codpart: function () {
      return this.pedv.codpart
    },

    part: function () {
      return this.$store.getters.getPart
    },

    selectedNates: function () {
      return this.$store.getters.getNates
    },

    codnates: function () {
      return this.pedv.codnates
    },

    prazodias: function () {
      return this.pedv.prazodias
    },

    prazo: function () {
      return this.pedv.prazo
    },

    validadedias: function () {
      return this.pedv.validadedias
    },

    dtvalidade: function () {
      return this.pedv.dtvalidade
    },

    parcelas: function () {
      return this.pedv.parcelas
    },

    title: function () {
      if (this.pedv.tppedv === 'P' && this.pedv.npedido === null) {
        return 'Incluindo Pedido'
      } else
        if (this.pedv.tppedv === 'P') {
          return 'Pedido de Venda [' + this.pedv.npedido + ']'
        } else
          if (this.pedv.ncotacao === null) {
            return 'Incluindo Orçamento'
          } else {
            return 'Orçamento [' + this.pedv.ncotacao + ']'
          }
    },

    disableTppedv: function () {
      //desabilita o campo tipo de documento este já for pedido de venda
      return this.pedv.tppedv === 'P' && this.pedv.codpedv != null
    },

    _nomeuf: function () {
      if (this.pedv.part) {
        if (this.pedv.part[0].uf) {
          return this.pedv.part[0].uf
        } else {
          return this.pedv.part[0].estado[0].uf
        }
      }
    },

    _nomemun: function () {
      if (this.pedv.part) {
        if (this.pedv.part[0].nomemun) {
          return this.pedv.part[0].nomemun
        } else {
          return this.pedv.part[0].mun[0].nomemun
        }
      }
    },

    _cnpjcpf: function () {
      //FORMATACAO DO CNPJ DO CLIENTE
      let doc = ''
      if (this.pedv.part) {
        doc = this.pedv.part[0].cnpjcpf
      }
      if (String(doc).length > 11) {
        doc = this.$formatCNPJ(doc)
      } else if (String(doc).length == 11) {
        doc = this.$formatCPF(doc)
      }
      return doc
    },

    _paramsPesquisa: function () {
      let params = {
        pedvit: this.pedvit,
        pedv: this.pedv
      }
      return params
    },

    _paramsDestaques: function () {
      let params = {
        pedvit: this.pedvit,
        pedv: this.pedv,
        produtosDestaque: true,
      }
      return params
    },
    showGuia: function () {
      return SysVars.guia
    },

    emiteCobranca: function () {
      return this.pedv.emitecobranca === 'S'
    },

  },

  filters: {
    format: function (value, decimals) {
      return formatValue(value, decimals)
    },
  },

  methods: {

    async checkAvisoNaturezaIcmFilialSemIE(nates) {
      if (!nates || this.unwatch) return
      if (nates.calcicm !== 'S') return
      if (nates.tpnf === 'D') return
      const cfopStr = String(nates.cfop || '').trim()
      if (cfopStr.startsWith('12') || cfopStr.startsWith('22') || cfopStr.startsWith('52') || cfopStr.startsWith('62')) {
        return
      }
      let codfil = (this.pedv ? this.pedv.codfil : null) || (this.$store.getters.getFilial ? this.$store.getters.getFilial.codfil : null)
      if (codfil) {
        await this.$store.dispatch('loadFilial', { id: codfil })
      }
      let filial = this.$store.getters.getFilial
      if (filial && (!filial.iest || String(filial.iest).trim() === '')) {
        this.$erpToastWarning(
          'Aviso: A filial emitente não possui Inscrição Estadual (contribuinte exclusivo IBS/CBS) e a natureza selecionada calcula ICMS. Operações com destaque de ICMS são rejeitadas pela SEFAZ (NT 2026.007), exceto em devoluções.'
        )
      }
    },

    async updateImpInfGeraisGarantia(value) {

      if (this.pedv.codpedv) {
        var modulo = 'sales/pedv/' + this.pedv.codpedv + '/impinfgeraisgarantia'
        let data_json = {};
        data_json.codpedv = this.pedv.codpedv;
        data_json.impinfgeraisgarantia = value;

        const data = await apiORDSpost(this.$store, modulo, data_json, 'post')
        if (data && data.errormessage) {
          console.log(data.validacao)
          this.$erpToastError('Erro ao enviar o pedido para remessa');
        }
      }
    },

    closeAlocacaoForm() {
      this.$modalForm(false)
      this.showFormAlocacao = false
      this.excluirAlocacao = false
      this.loadData(this.pedv.codpedv)
    },

    handleAlocacao() {
      this.$modalForm(true)
      this.showFormAlocacao = true
    },

    handleExcluirAlocacao() {
      this.$modalForm(true)
      this.excluirAlocacao = true
      this.showFormAlocacao = true
    },

    statusColor: function (value) {
      let color = 'badge-blue'

      if (value == 'C') {
        color = 'badge-red'
      } else if (value == 'D') {
        color = 'badge-orange'
      } else if (value == 'P') {
        color = 'badge-green'
      }

      return color
    },

    closeForm() {
      if (this.$route.params && this.$route.params.novo == 'guia')
        this.$router.go(-1)
      else
        if (this.$route.params && this.$route.params.novo == 'novo')
          this.$router.push('/pedidolist')
        else
          if (this.$route.params && this.$route.params.novo)
            this.$router.go(-1)
          else
            this.$emit('closeform')
    },

    closePartForm(id) {
      //ao fechar o formulario de inclusao de clientes
      if (id) this.pedv.codpart = id
      this.showPartForm = false
    },

    closeNatesForm(id) {
      //ao fechar o formulario de inclusao de naturezas
      if (id) this.pedv.codnates = id
      this.showNatesForm = false
    },

    closeContatoForm(id) {
      //ao fechar o formulario de inclusao de vendedor
      if (id) this.pedv.seqcontato = id
      this.showContatoForm = false
    },

    closeNfForm() {
      //ao fechar o formulario de faturamento
      this.showNfForm = false
    },

    handleShowDestaque() {
      this.showListaDestaques = true
    },

    closeDestaque() {
      this.showListaDestaques = false
    },

    handleFaturar(tipo) {
      console.log(tipo)
      console.log(this.pedv.varejo)
      console.log(this.pedv)

      let self = this
      //salva o pedido e direciona para o faturamento
      if (tipo = 'NFE' && this.pedv.varejo != 'S') {
        this.gravaPedido().then(function () {
          self.$router.push('/nf/' + self.pedv.codpedv);
        })
        return
      }
      let esp = ''
      if (tipo == 'NFCe')
        esp = '65'
      else
        esp = '55'

      this.apiGerarNF(esp).then(function () {
        let tipo = self.$certificadoCheck(self.pedv.codfil)
        if (tipo == 'A1') {
          self.autorizaNFeA1(self.pedv.nf, self.NFeResponseCallbackA1).then(function () {
          });
        } else if (tipo == "A3") {
          self.autorizaNFeA3(self.pedv.nf, self.NFeResponseCallbackA3).then(function () {
          });
        }
      });
    },

    NFeResponseCallbackA3(response) {
      //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO A3
      if (response.status != "success") {
        this.$erpToastError(response.message);
      } else {
        if (response.response && response.response.nf.length > 0 && response.response.nf[0].cstat == "100") {
          this.$erpToastSuccess("NFe Autorizada");
          apiDownloadPDF(this, "print/danfe/" + response.response.nf[0].codnf, null, null, true);
        }
        else {
          this.$erpToastError(response.response.xmotivo);
          this.$router.push("/nf/" + response.response.nf[0].codnf + "?tipo=view");
        }
      }
    },

    async NFeResponseCallbackA1(response) {
      let rejeitada = false;
      if (response.data) {
        if (!response.data.errmessages) {
          if (response.data.nf.length > 0) {
            if (response.data.nf[0].cstat != "100") {
              rejeitada = true;
            }
          } else {
            rejeitada = true;
          }
        }
      }

      if (rejeitada) {
        this.$erpToastError('NFe Rejeitada');
        this.$router.push("/nf/" + this.pedv.nf.codnf + "?tipo=view");
      }

      //CASO NF-e AUTORIZADA SERÁ ABERTO TELA DE IMPRESSÃO
      if (response.data.nf.length > 0) {
        if (response.data.nf[0].codnf) {
          this.$erpToastSuccess("NFe Autorizada");
          apiDownloadPDF(this, "print/danfe/" + response.data.nf[0].codnf, null, null, true);
        }
      }
    },

    handleIncluirCliente() {
      //exibe tela de cadastro do cliente
      if (this.isView) {
        return
      }
      this.showPartForm = true
    },

    handleIncluirNates() {
      //exibe tela de cadastro da natureza
      if (this.isView) {
        return
      }
      this.showNatesForm = true
    },

    handleIncluirVend() {
      //exibe tela de cadastro do cliente
      if (this.isView) {
        return
      }
      this.showVendForm = true
    },

    handleIncluirContato() {
      if (this.pedv.codpart == null) {
        this.$erpToastError('Selecione um cliente antes de incluir um contato.')
        return
      }
      this.showContatoForm = true
    },

    handleContinuar() {
      //BOTAO "CONTINUAR" DA TELA DE INCLUSAO DE PEDIDO
      //EFETUA A VALIDACAO DOS CAMPOS INICIAIS E ABRE OS DEMAIS DADOS DE CABECALHO
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
        } else if (this.validacaoInicial()) {
          this.handleSaveCab()
        }
      })
    },

    validarParcelas() {
      let soma = 0;
      for (var x = 0; x <= this.pedvpar.length - 1; x++) {
        if (x > 0) {
          if (this.pedvpar[x].dias < this.pedvpar[x - 1].dias) {
            this.$erpToastError('Os dias da ' + (x + 1) + 'º parcela deve ser maior que da ' + (x) + 'º parcela .')
            return false;
          }
          if (this.pedvpar[x].dtv < this.pedvpar[x - 1].dtv) {
            this.$erpToastError('O Vencimento da ' + (x + 1) + 'º parcela deve ser maior que da ' + (x) + 'º parcela .')
            return false;
          }
          if (this.pedvpar[x].vlr <= 0) {
            this.$erpToastError('O Valor da ' + (x + 1) + 'º parcela deve ser maior que 0.')
            return false;
          }

        }
        soma = Number(soma) + Number(this.pedvpar[x].vlr);
        soma = Number((soma).toFixed(2));
      }

      if ((this.pedv.stpedv != 'D') && (this.pedvpar.length > 0)) {
        if (Number(soma) != Number(this.pedv.totger)) {
          this.$erpToastError('O Total das parcelas está diferente do total do pedido.')
          return false;
        }
      }

      return true

    },

    handleTotalizar(close) {
      //BOTAO TOTALIZAR PEDIDO - EFETUA VALIDACOES E ENCERRA A DIGITACAO DO PEDIDO (PEDIDO PASSA PARA STATUS PENDENTE)
      if (this.pedvit && this.pedvit.length == 0) {
        this.$erpToastError('O pedido não possui nenhum item. Por favor adicione itens no pedido.')
        return
      }

      if (!this.validarParcelas()) {
        return
      }

      if (this.pedv.parcelas == null) {
        this.pedv.parcelas = 0
      }
      //if (!close) {
      //    this.calculaParcelas()
      //}
      this.pedv.stpedv = 'P'
      let self = this
      this.gravaPedido().then(function () {
        if (close) {
          self.closeForm()
        } else {
          if (self.$refs.parcelas) {
            self.$refs.parcelas.focus()
            self.loadControleEstoqueFilial(self.pedv.codfil)
            let elmnt = document.getElementById("parcelas")
            elmnt.scrollIntoView() //POSICIONA NO ELEMENTO CONDICAO DE PAGAMENTO
          }
        }
      })
    },

    async loadControleEstoqueFilial(codfil) {
      //checa se possui controle de estoque na filial
      if (!codfil) {
        this.controleEstoqueAtivado = false
        return
      }

      let parametros = {}

      await this.$store.dispatch('loadFilial', { id: codfil })
      if (this.$store.getters.getFilial) {
        let filial = this.$store.getters.getFilial
        if (filial.parametros) {
          parametros = JSON.parse(filial.parametros)
        }
      }
      this.controleEstoqueAtivado = parametros.controlaestoque
    },

    async getParcelasFormapagParametrosFilial(codfil) {
      //checa se possui controle de estoque na filial
      if (!codfil)
        return '99'

      let parametros = {}

      await this.$store.dispatch('loadFilial', { id: codfil })
      if (this.$store.getters.getFilial) {
        let filial = this.$store.getters.getFilial
        if (filial.parametros) {
          parametros = JSON.parse(filial.parametros)
        }
      }

      if (parametros)
        if (parametros.parcelas)
          if (parametros.parcelas.formapag)
            return parametros.parcelas.formapag;
      return '99';
    },

    handleGerarPedido() {
      //BOTAO PARA TRANSFORMAR O PEDIDO EM ORÇAMENTO
      if (this.pedvit && this.pedvit.length == 0) {
        this.$erpToastError('O pedido não possui nenhum item. Por favor adicione itens no pedido.')
        return
      }
      if (!this.validarParcelas()) {
        return
      }

      let self = this
      this.gravaPedido('gerarpedido').then(function () {
        self.loadControleEstoqueFilial(self.pedv.codfil)
        self.$erpToastSuccess('O pedido foi gerado');
      })
    },

    handleOrcamentoPedido() {
      //BOTAO PARA TRANSFORMAR O PEDIDO EM ORÇAMENTO
      if (this.pedvit && this.pedvit.length == 0) {
        this.$erpToastError('O pedido não possui nenhum item. Por favor adicione itens no pedido.')
        return
      }
      if (!this.validarParcelas()) {
        return
      }

      if (confirm("Confirma orçamento perdido?")) {
        let self = this
        this.gravaPedido('perdido').then(function () {
          self.$erpToastError('Orçamento perdido');
        })
      }
    },

    handleInfAdicionais() {
      //click do botao outras informacoes exibe a tela com dados para alteracao
      this.showFormInfAd = true
    },

    handleSaveCab() {
      //botao salvar dados de cabecalho
      if (this.isView) {
        return
      }
      this.gravaPedido()
      if (this.errmessages.length) {
        //se retornou erros continua parado na mesma tela
      } else {
        this.formNew = false
        this.formOrder = true
        this.showFormInfAd = false
        this.formItemsPedido = true
      }
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
      })
    },

    handleCopia() {
      //efetua a copia do pedido
      this.apiDuplica()
    },

    handleAddItem() {
      //inclusao de item individual
      if (this.isView) {
        this.$erpToastError('Não permitido')
        return
      }

      this.pedvit_update = { ...this.$store.getters.getEntities.pedvit },
        this.pedvit_update.pdesc1 = this.pedv.pdesc1
      this.pedvit_update.pdesc2 = this.pedv.pdesc2
      this.pedvit_update.pdesc3 = this.pedv.pdesc3
      this.pedvit_update.pdesc4 = this.pedv.pdesc4
      this.pedvit_update.finalidade = this.pedv.finalidade
      this.updateItem = false
      this.showFormItem = true
    },

    closeFormItem() {
      //fecha tela de inclusao de item
      this.showFormItem = false
      this.showFormInfAd = false
      this.formOrder = true
    },

    handleSalvarItens(pedvit) {
      //efetua a inclusao de item no pedido
      if (this.pedvit && pedvit.length == 0) {
        return
      }
      this.showFormItem = false
      this.formOrder = true

      let itens = []

      if (pedvit.length) {
        //se receber uma lista de itens, ajusta a lista para efetuar gravacao
        for (var x = 0; x < pedvit.length; x++) {
          if (pedvit[x].codpedv) {
            itens.push(pedvit[x])
          } else {
            let it = { ...this.$store.getters.getEntities.pedvit }
            // it.codpedv = this.pedv.codpedv
            it.coditem = pedvit[x].coditem
            it.vlr = pedvit[x].vlr
            it.uni = pedvit[x].uni
            it.qtuni = pedvit[x].qtuni
            it.pedvgrade = pedvit[x].pedvgrade
            if (pedvit[x].tabelas_desconto)
              it.descontotab = pedvit[x].tabelas_desconto.descontos
            it.pdesc1 = pedvit[x].pdesc1
            it.pdesc2 = pedvit[x].pdesc2
            it.pdesc3 = pedvit[x].pdesc3
            it.pdesc4 = pedvit[x].pdesc4
            it.pedcliit = pedvit[x].pedcliit
            it.iskit = pedvit[x].iskit == 'S'
            itens.push(it)
          }
        }
      } else {
        itens.push(pedvit)
      }
      //EFETUA A GRAVACAO DOS ITENS NO PEDIDO
      this.apiItens(itens, false, false)

      this.closeDestaque()

      this.$refs.addList.focus()

    },

    handleShowGradeItem(index) {
      //EXIBE A GRADE DO ITEM NA LISTA DE ITENS
      if (this.pedvit[index].showGrade) {
        this.pedvit[index].showGrade = false
      } else {
        this.$set(this.pedvit[index], 'showGrade', true)
      }
    },

    handleEditItem(nSeq, view) {
      //EDITAR O ITEM DO PEDIDO
      this.pedvit_update = {}
      //localiza o item para alteracao atraves da sequencia
      for (var x = 0; x < this.pedvit.length; x++) {
        if (this.pedvit[x].itped == nSeq) {
          this.pedvit_update = { ...this.pedvit[x] }
        }
      }
      this.formItemView = view //indica se é alteração ou somente visualizacao
      this.updateItem = true
      this.showFormItem = true
    },

    handleItemDeleteMsg(nSeq) {
      //EXCLUI O ITEM DO PEDIDO
      this.pedvit_update = {}
      //localiza o item para alteracao atraves da sequencia
      for (var x = 0; x < this.pedvit.length; x++) {
        if (this.pedvit[x].itped == nSeq) {
          this.pedvit_update = { ...this.pedvit[x] }
        }
      }
      this.DELETE_ITEM_MESSAGE = true;
    },

    async handleItemDelete(nSeq) {
      //remove o item do pedido
      this.DELETE_ITEM_MESSAGE = false;
      var pedvit = [];
      pedvit.push(this.pedvit_update)
      await this.apiItens(pedvit, false, true)
    },

    handleRetorna() {
      //TRATAMENTO DO BOTAO RETORNAR (TELA DE INCLUSAO, DADOS DO PEDIDO E TELA PRINCIPAL DO PEDIDO)
      if (this.formNew) {
        //FECHA A TELA DE INCLUSAO DO PEDIDO
        this.closeForm()
      } else if (this.formOrder) {
        //FECHA A TELA DE EDICAO DO PEDIDO
        this.closeForm()
      }
    },

    //CHAMADAS API

    async gravaPedido(operacao) {
      //efetua a gravacao do pedido

      if (this.isView) {
        return
      }

      this.unwatch = true

      if (operacao == 'gerarpedido')
        this.pedv.tppedv = 'P'
      else
        if (operacao == 'perdido')
          this.pedv.tppedv = 'R'
        else
          if (operacao == 'cancelar')
            this.pedv.stpedv = 'C'


      this.pedv.pedvit = [...this.pedvit]
      this.pedv.pedvpar = [...this.pedvpar]
      var sendData = {}
      sendData = { pedv: this.pedv }

      var metodo = 'post'
      var update = false
      if (this.pedv.codpedv != null) {
        metodo = 'put'
        update = true
      }

      var modulo = 'sales/pedv/'

      const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
      if (data.items) {
        this.pedv = data.items[0];
        if (this.pedv.pedvit)
          this.pedvit = this.pedv.pedvit
        if (this.pedv.anexos && this.pedv.anexos.length)
          this.anexos = this.pedv.anexos
        else
          this.anexos = []
        if (this.pedv.pedvpar) {
          this.pedvpar = this.pedv.pedvpar
        }
        let validation = JSON.parse(this.pedv.validation)
        if (validation && validation.errmessages && validation.errmessages.length) {
          this.errmessages = validation
          this.$scrollTo(0)
          this.$erpToastError('Por favor corrija os erros de validação')
        } else
          if (this.pedv.stpedv == 'C') {
            this.$erpToastWarning('O pedido foi cancelado')
            this.closeForm()
          } else {
            this.errmessages = {}
            if (update) {
              //this.$erpToastSuccess('Pedido alterado')
            }
          }
      }
      this.updateActions() //ATUALIZA AS OPCOES DO BOTAO "MAIS ACOES" AO CARREGAR UM PEDIDO
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
        this.unwatch = false
      })

    },

    async apiDuplica() {
      //efetua a copia do pedido
      var metodo = 'post'
      var modulo = 'sales/pedv/duplica'
      var sendData = { pedv: this.pedv.codpedv }

      const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
      if (data.items) {
        this.pedv = data.items[0]
        if (this.pedv.tppedv === 'P') {
          this.$erpToastSuccess('Pedido copiado com sucesso. O novo pedido criado é: ' + this.pedv.npedido)
        } else {
          this.$erpToastSuccess('Orçamento copiado com sucesso. O novo orçamento criado é: ' + this.pedv.ncotacao)
        }
        this.errmessages = {}
        if (this.pedv.validation) {
          this.errmessages = JSON.parse(this.pedv.validation)
        }
      }
    },

    async apiItens(pedvIt, cancelItem, deleteItem) {
      //efetua a gravacao dos itens do pedido
      this.pedv.pedvit = { ...this.pedvit }
      var sendData = {}
      sendData = { pedv: this.pedv } //pega o cabecalho do pedido
      if (pedvIt.length) {
        sendData.pedv.pedvit = pedvIt //adiciona os novos itens ao cabecalho
      } else {
        sendData.pedv.pedvit = []
        sendData.pedv.pedvit.push(pedvIt)
      }

      let modulo = 'sales/pedvit/'
      let metodo = 'post'
      if (this.formNew) {
        modulo = 'sales/pedv/'
      } else
        if (this.updateItem) {
          metodo = 'put'
        } else
          if (cancelItem) {
            modulo = 'sales/pedvit/cancel/'
          } else
            if (deleteItem) {
              modulo = 'sales/pedvit/delete/'
            }

      const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
      if (deleteItem) {
        await this.loadData(this.pedv.codpedv)
        this.$erpToastSuccess('O produto foi excluído do pedido.')
      } else
        if (data.items) {
          this.pedv = data.items[0]
          this.pedvit = data.items[0].pedvit
          this.updateActions() //ATUALIZA AS OPCOES DO BOTAO "MAIS ACOES" AO CARREGAR UM PEDIDO
          if (cancelItem)
            this.$erpToastSuccess('O produto foi cancelado com sucesso.')
          else if (this.updateItem)
            this.$erpToastSuccess('Item alterado com sucesso.')
          else if (pedvIt.length && pedvIt.length > 1) {
            this.$erpToastSuccess('Os produtos selecionados foram adicionados.')
          } else {
            this.$erpToastSuccess('Os produtos selecionados foram adicionados.')
          }
          if (this.pedv.validation) {
            this.errmessages = JSON.parse(this.pedv.validation)
          } else {
            this.errmessages = {}
          }
        }

      this.updateItem = false
      this.formNew = false
    },

    handleCancelMsg(nSeq) {
      //cancelar o pedido
      //exibe a confirmacao do cancelamento
      this.CANCEL_MESSAGE = true;
    },

    handleItemCancelMsg(nSeq) {
      //cancelar o item do pedido
      this.pedvit_update = {}
      //localiza o item para cancelar atraves da sequencia
      for (var x = 0; x < this.pedvit.length; x++) {
        if (this.pedvit[x].itped == nSeq) {
          this.pedvit_update = { ...this.pedvit[x] }
        }
      }
      this.pedvit_update.stpedv = 'C'

      //exibe a confirmacao do cancelamento
      this.CANCEL_ITEM_MESSAGE = true;
    },

    handleItemCancel() {
      //efetiva o cancelamento do item
      this.CANCEL_ITEM_MESSAGE = false;
      var pedvit = [];
      pedvit.push(this.pedvit_update)
      this.apiItens(pedvit, true, false)
    },

    handleCancel() {
      //efetiva o cancelamento do pedido
      this.CANCEL_MESSAGE = false;
      this.gravaPedido('cancelar')
    },

    handleCloseMessage() {
      this.CANCEL_MESSAGE = false;
      this.CANCEL_ITEM_MESSAGE = false;
      this.DELETE_ITEM_MESSAGE = false;
    },

    handleEmail() {
      // SALVA O PEDIDO E ENVIA EMAIL
      let self = this
      this.gravaPedido().then(function () {
        self.handleFormEmail()
      })
    },

    handleAction(act) {
      //click do botao "mais acoes"
      if (act == 12) {
        this.$router.push('/banking?codpedv=' + this.pedv.codpedv);
      }
      if (act == 10) {
        this.handleAnexarDocumento()
      }
      if (act == 20) {
        this.handleExcluirAlocacao()
      }
      if (act == 5) {
        this.apiDuplica()
      }
      else if (act == 4) {
        this.handleCancelMsg()
      }
      else if (act == 1) {
        let self = this
        this.gravaPedido().then(function () {
          self.codpedvImpressao = self.pedv.codpedv
          self.showImpressao = true
          self.$nextTick(function () {
            self.$refs.impressao.print()
          })
        })
      }
    },
    handleClosePrint() {
      this.showImpressao = false
    },
    handleAnexarDocumento() {
      //ANEXAR DOCUMENTOS AO PEDIDO
      if (!this.showAnexo) {
        this.showAnexo = true
      }
      this.$nextTick(function () {
        this.$refs.anexos.handleClickAdiciona()
      })
    },

    handleChangeAnexos(anexosList) {
      //ATUALIZA A LISTA DE ANEXOS
      this.anexos = anexosList
    },

    handleFormEmail() {
      //Abre a tela para envio de email
      //carrega o template da mensagem antes do envio (ords/webdata/template/salesorder/:id)

      this.showFormEmail = true
    },

    closeFormEmail() {
      this.showFormEmail = false
    },

    async handleSendEmail(data) {
      //cahamda para envio de email do pedido
      this.closeFormEmail()
      const email = await apiEmailPDF(this, 'pedv/' + this.pedv.codpedv, data)
    },

    updateActions() {
      /* ATUALIZA AS OPCOES DO BOTAO "MAIS ACOES"
      - quando pendente permite imprimir, enviar, faturar, cancelar
      - quando em digitacao permite cancelar
      - quando liquidado ou cancelado nao permite açoes
      */
      this.btNFC = this.pedv.varejo == 'S' && this.pedv.stpedv == 'P'

      this.btEnviar = this.pedv.stpedv == 'P' && this.pedv.tppedv != 'R' || (this.pedv.stpedv == 'F');
      this.btImprimir = (this.pedv.stpedv == 'P' && this.pedv.tppedv != 'R') || (this.pedv.stpedv == 'F');
      this.btFaturar = (this.pedv.movest !== 'S' || this.alocacaoEfetuada || !this.controleEstoqueAtivado) && this.pedv.stpedv == 'P' && this.pedv.tppedv == 'P' && !(this.pedv.data_leitura);
      // this.btEnviar = ((this.pedv.stpedv == 'P' || this.pedv.stpedv == 'F') && this.pedv.tppedv != 'R')
      // this.btImprimir = ((this.pedv.stpedv == 'P' || this.pedv.stpedv == 'F') && this.pedv.tppedv != 'R')
      // this.btFaturar = this.pedv.stpedv == 'P' && this.pedv.tppedv == 'P' && !(this.pedv.data_leitura)
      this.btCancelar = this.pedv.varejo != 'S' && this.pedv.tppedv === 'P' && this.pedv.nf_pendente === 0 && this.pedv.fin_remessa === 0 && this.pedv.fin_baixado === 0

      var act = {}
      this.moreActions = []
      if (this.pedv.varejo != 'S') {
        if (this.pedv.stpedv == 'P') {
          if (this.btCancelar) {
            act = { action: 4, label: 'Cancelar' }
            this.moreActions.push(act);
          }
        }
        if (this.pedv.tppedv === 'P') {
          act = { action: 5, label: 'Copiar Pedido' }
          this.moreActions.push(act);
        } else {
          act = { action: 5, label: 'Copiar Orçamento' }
          this.moreActions.push(act);
        }
        if (this.pedv.tppedv == 'P' && this.alocacaoEfetuada && this.pedv.stpedv !== 'F') {
          act = { action: 20, label: 'Excluir Alocação' }
          this.moreActions.push(act)
        }
      }
        if (this.pedv.stpedv == 'P' || this.pedv.stpedv == 'D') {
          act = { action: 10, label: 'Anexar Documento' }
          this.moreActions.push(act)
        }

        if (this.emiteCobranca) {
          act = { action: 12, label: 'Enviar Cobrança' }
          this.moreActions.push(act);
        }
    },

    textOption(value, field) {
      var item = field.options.filter(x => x.id === value);
      if (item.length) { return item[0].text }
    },

    calculaTotal() {
      //calcula o total do pedido
      var t = 0
      for (var x = 0; x < this.pedvit.length; x++) {
        this.pedvit[x].totliq = this.pedvit[x].qt * this.pedvit[x].vlr
        this.pedvit[x].totliq = calcDesconto(this.pedvit[x].totliq, this.pedvit[x].pdesc1, this.pedvit[x].pdesc2, this.pedvit[x].pdesc3, this.pedvit[x].pdesc4, 2, true)
        t += this.pedvit[x].totliq
      }
      this.pedv.totliq = t
    },

    validacaoInicial() {
      //VALIDA A SITUACAO DE CREDITO DO CLIENTE, STATUS DO CLIENTE E NATUREZA DE OPERACAO
      this.isValidCabec = true

      if (this.pedv.nates && this.pedv.nates.length && this.pedv.nates[0].stnates == 'I') {
        this.$erpToastError('A Natureza de saída informada está inativa')
        this.isValidCabec = false
      }
      if (this.pedv.part[0].stcred != 'L') {
        this.$erpToastError('Cliente com crédito bloqueado')
        this.isValidCabec = false
      }
      if (this.pedv.part[0].stpart == 'I') {
        this.$erpToastError('Cliente inativo')
        this.isValidCabec = false
      }
      return this.isValidCabec
    },

    validacaoCab() {
      //validar o cliente quanto ao status do credito, status e natureza de operacao
      this.isValidCabec = true

      if (this.pedv.parttr.length && this.pedv.parttr.stpart == 'I') {
        this.$erpToastError('Transportadora inativa')
        this.isValidCabec = false
      }
      if (this.pedv.vend.length && this.pedv.vend.stpart == 'I') {
        this.$erpToastError('Representante inativo')
        this.isValidCabec = false
      }
      if (this.pedv.tabpre.length && this.pedv.tabpre.sttabpre == 'I') {
        this.$erpToastError('Tabela de preço inativa')
        this.isValidCabec = false
        //falta validar a data da tabela de preco
      }
      if (this.pedv.condicao.length && this.pedv.condicao.ativo != 'A') {
        this.$erpToastError('Condição de pagamento inativa')
        this.isValidCabec = false
      }
    },

    async loadData(id) {
      //carrega o pedido para alteracao ou visualizacao
      this.partTabela = false
      this.partCodTabpre = null

      this.unwatch = true
      await this.$store.dispatch('loadPedv', { id: id })
      if (this.$store.getters.getPedv) {
        this.pedv = { ...this.$store.getters.getPedv[0] }
        if (this.pedv.pedvit)
          this.pedvit = this.pedv.pedvit
        if (this.pedv.part[0].codtabpre) {
          this.partCodTabpre = this.pedv.part[0].codtabpre
          this.partTabela = true
        }
        if (this.pedv.validation)
          this.errmessages = JSON.parse(this.pedv.validation)
        if (this.pedv.anexos && this.pedv.anexos.length)
          this.anexos = this.pedv.anexos
        else
          this.anexos = []
        if (this.pedv.pedvpar) {
          this.pedvpar = this.pedv.pedvpar
        }
        this.updateActions() //ATUALIZA AS OPCOES DO BOTAO "MAIS ACOES" AO CARREGAR UM PEDIDO
      }
      this.loadControleEstoqueFilial(this.pedv.codfil)
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
        this.unwatch = false
      })
    },

    // changeTab (idx) {
    //     //controle de visualizacao das paginas
    //     this.formItemsPedido = true
    //     this.activeTab = idx
    // },

    calculaParcelas() {
      //CALCULA PARCELAS DO PEDIDO
      let vDias = 0;
      let soma = 0;

      if (this.pedvpar.length && this.pedvpar[0].dias > 0) {
        vDias = this.pedvpar[0].dias
      }

      this.pedvpar = [];
      let vlr = 0
      if (this.pedv.parcelas == '0') {
        let parcela = { ...this.$store.getters.getEntities.pedvpar }
        parcela.dtv = this.pedv.data
        parcela.vlr = this.pedv.totger
        parcela.obspar = ''
        parcela.dias = vDias
        this.getParcelasFormapagParametrosFilial(this.pedv.codfil).then(function (v) {
          parcela.formapag = v
        });

        if (parcela.formapag == null) {
          parcela.formapag = "99"
        }
        this.pedvpar.push(parcela)
      } else {
        for (var x = 1; x <= this.pedv.parcelas; x++) {
          let parcela = { ...this.$store.getters.getEntities.pedvpar };
          parcela.dias = x * 30;
          parcela.dtv = this.$addDays(this.pedv.data, parcela.dias)
          vlr = this.pedv.totger;
          vlr = arr(vlr / this.pedv.parcelas, 2, true);
          parcela.vlr = vlr;
          soma = Number(soma) + Number(vlr);
          soma = Number((soma).toFixed(2));

          if (x == this.pedv.parcelas) {
            if (soma > this.pedv.totger) {
              parcela.vlr = parcela.vlr - (soma - this.pedv.totger);
            } else if (soma < this.pedv.totger) {
              parcela.vlr = Number(parcela.vlr) + (Number(this.pedv.totger) - Number(soma));
            }
          }

          parcela.obspar = '';

          this.getParcelasFormapagParametrosFilial(this.pedv.codfil).then(function (v) {
            parcela.formapag = v
          });

          if (parcela.formapag == null) {
            parcela.formapag = "99"
          }
          this.pedvpar.push(parcela);

        }
      }
      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
      })
    },

    pedvparVlrChange(index) {
      //evento de controle de alteracao do valor da parcela
      //quando usuario alterar o valor de uma parcela, refaz as demais parcelas
      if (this.pedv.parcelas <= 1) {
        return
      }
      let vlrparcial = 0
      let vlrnovaparcela = 0
      for (var x = 0; x <= index; x++) {
        vlrparcial = vlrparcial + parseFloat(this.pedvpar[x].vlr)
      }
      if (vlrparcial < this.pedv.totger) {
        vlrnovaparcela = (this.pedv.totger - vlrparcial) / (this.pedv.parcelas - (index + 1))
        vlrnovaparcela.toFixed(2)
      } else {
      }
      for (var x = index + 1; x <= this.pedvpar.length - 1; x++) {
        this.pedvpar[x].vlr = vlrnovaparcela
      }
    },

    pedvparDiasChange(index) {
      //evento de controle de alteracao do nr de dias de vencimento da parcela
      this.pedvpar[index].dtv = this.$addDays(this.pedv.data, this.pedvpar[index].dias)
    },

    pedvparDtvChange(index) {
      //evento de controle de alteracao do nr de dias de vencimento da parcela
      this.pedvpar[index].dias = this.$daysBetween(this.pedv.data, this.pedvpar[index].dtv);
    },

    usuarioTemPermissaoNaTabelaPreco(codtabpre) {
      if (codtabpre) {
        if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas && this.$store.getters.getParametrosUsuario.vendas.tabelaspreco && this.$store.getters.getParametrosUsuario.vendas.tabelaspreco.length > 0) {
          let liberado = this.$store.getters.getParametrosUsuario.vendas.tabelaspreco.filter((obj) => { return obj == codtabpre })
          if (liberado.length > 0) {
            return true
          }
        } else {
          return true
        }
      }
      return false
    },


    async carregaDadosCliente() {
      await this.$store.dispatch('loadPart', { id: this.pedv.codpart })
      //atualiza os dados do cliente no pedido quando informado um codigo do cliente
      if (!this.pedv.part || this.pedv.part[0].codpart != this.pedv.codpart) {
        this.pedv.part = this.part
        this.pedv.finalidade = this.pedv.part[0].tpcliente
        this.pedv.codnates = this.pedv.part[0].codnates
        this.pedv.nates = this.pedv.part[0].nates[0]
        this.pedv.codvendr = this.pedv.part[0].codvendr
        this.pedv.vendr = this.pedv.part[0].vendr[0]
        this.partCodTabpre = null
        this.partTabela = false
        if (this.usuarioTemPermissaoNaTabelaPreco(this.pedv.part[0].codtabpre)) {
          this.pedv.codtabpre = this.pedv.part[0].codtabpre
          this.partCodTabpre = this.pedv.part[0].codtabpre
          this.partTabela = true
        }
        this.pedv.tabpre = this.pedv.part[0].tabpre[0]
        this.pedv.codparttr = this.pedv.part[0].codparttr
        this.pedv.parttr = this.pedv.part[0].parttr[0]
        this.pedv.codcondicao = this.pedv.part[0].codcondicao
        this.pedv.condicao = this.pedv.part[0].condicao[0]
        this.pedv.codvend = this.pedv.part[0].codvend
        this.pedv.vend = this.pedv.part[0].vend[0]
        if (this.pedv.part[0].partcontato.length > 0)
          this.pedv.seqcontato = this.pedv.part[0].partcontato[0].seqcontato
        if (this.pedv.part[0].tpfrete)
          this.pedv.tpfrete = this.pedv.part[0].tpfrete
      }
      this.validacaoInicial()
    }

  },

  watch: {
    part: function () {

    },

    selectedNates: function () {
      //atualiza a natureza de operacao
      this.pedv.nates = { ...this.selectedNates }
      this.checkAvisoNaturezaIcmFilialSemIE(this.selectedNates)
    },

    codpart: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.carregaDadosCliente()
      }
    },

    codnates: function () {
      //carrega os dados da natureza selecionada pelo codigo => /cg/nates/id
      this.$store.dispatch('loadNates', { id: this.pedv.codnates })
    },

    prazodias: function () {
      //CALCULA O PRAZO DE ENTREGA QUANDO ALTERAR O PRAZO EM DIAS
      if (this.unwatch) return
      if (this.pedv.prazodias > 0) {
        this.pedv.prazo = this.$addDays(this.pedv.data, this.pedv.prazodias)
      }
    },

    prazo: function () {
      //console.log(this.pedv.prazo)
    },

    validadedias: function () {
      //CALCULA O PRAZO DE ENTREGA QUANDO ALTERAR O PRAZO EM DIAS
      if (this.unwatch) return
      if (this.pedv.validadedias > 0) {
        this.pedv.dtvalidade = this.$addDays(this.pedv.data, this.pedv.validadedias)
      }
    },

    dtvalidade: function () {
      //console.log(this.pedv.dtvalidade)
    },


    parcelas: function () {
      //calcula numero de parcelas da condicao de pagamento
      if (this.unwatch) return
      this.calculaParcelas()
    },
  },

  async created() {
    //this.$store.dispatch('clearItemSales')

    //carrega parametros do usuario para bloqueio das tabelas de precos
    this.$store.dispatch('loadParametrosUsuario')

    //carrega as tabelas de precos liberadas para o usuario no computed "tabelas_preco_options"
    this.$store.dispatch('loadTabpre', {})

    //carrega lista de destaques
    this.$store.dispatch('loadDestaq', {})

    //carrega lista de cadastro de status para selecao
    this.$store.dispatch('loadPdstatus', {})


    this.metadata.pedv.parcelas.options.sort(function (a, b) { return (Number(a.id) > Number(b.id)) ? 1 : ((Number(b.id) > Number(a.id)) ? -1 : 0); })

    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
    })

    this.$scrollTo(0)

    let index = this.index

    let incluir = this.crud == SysVars.crudI

    if (this.$route.params)
      if (this.$route.params.novo == 'novo')
        incluir = true
      else
        if (this.$route.params.novo)
          index = this.$route.params.novo

    if (incluir)
      this.crudText = this.$crudText(SysVars.crudI)

    if (incluir) {
      this.formNew = true
      this.pedv.data = this.$getDate()
      this.pedv.stpedv = 'D'
      this.pedv.finalidade = 'F'
      this.pedv.indpresencial = '0'
      this.pedv.bonif = 'N'
      this.pedv.amostra = 'N'
      this.pedv.pgantecipado = 'N'
      this.pedv.tpfrete = '9'
      this.pedv.tppedv = 'O'
      if (this.tabelas_preco_options && this.tabelas_preco_options.length > 0) {
        this.pedv.codtabpre = this.tabelas_preco_options[0].id;
      } else {
        this.pedv.codtabpre = '1'
      }
      this.pedv.movest = 'S'
      this.unwatch = false
      this.updateActions()
      this.$nextTick(function () {
        this.$refs.part.focus()
      })
      if (this.showGuia) {
        let params = { filter: null }
        await this.$store.dispatch('loadPedvList', params)
        this.hasManyPedidos = (this.$store.getters.getPedvList.length >= 1)
        if (this.showGuia && !this.hasManyPedidos) {
          var tourguide = new Tourguide({
            steps: this.steps
          });

          tourguide.start();
        }
      }
    } else {
      this.formOrder = true
      this.loadData(index)
    }

  }

}

</script>

<template>
  <div>

    <!-- FORMULARIO PRINCIPAL DO PEDIDO/ORCAMENTO  -->
    <div class="default-container" id="formOrder">
      <div class="row">
        <div class="col-md-6 col-12">
          <h4 class="def-title"> {{ title }}
          </h4>
        </div>
        <div class="col-md-6 col-12">
          <div class="float-right">
            <v-button label="Retornar" title="" icon="fa-arrow-left" @click="handleRetorna()"></v-button>
            <v-button v-if="btTotalizar" label="Finalizar Digitação de Produtos" :nb-btdef="true"
              title="Efetua a totalização do pedido e encerra a digitação" @click="handleTotalizar()"></v-button>
            <v-button title="Visualizar" icon="fa-print" v-show="btImprimir" :nb-btdef="false" @click="handleAction(1)">
            </v-button>
            <v-button title="Enviar Email" icon="fa-envelope-open" v-show="btEnviar" :nb-btdef="false"
              @click="handleEmail()"></v-button>
            <v-button v-if="moreActions.length > 0" :actions="moreActions" @click="handleAction"></v-button>
          </div>
        </div>
        <div class="col-md-12 col-12" v-if="pedv.codpedv !== null">
          <span class="lbl-list pr-3"><i class="fa fa-user mr-2"></i>Proprietário {{ pedv.usuario_nome }} </span>
          <span class="lbl-list pr-3"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> Criado em {{ pedv.data |
              formatDataExtenso
          }}</span>
          <span v-if="pedv.ncotacao" class="lbl-list pr-3">Orçamento {{ pedv.ncotacao }}</span>
        </div>
      </div>

      <div class="row mt-2" v-if="pedv.codpedv !== null">
        <div class="col-md-12 col-12">
          <span v-if="pedv.varejo == 'S'" class="badge badge-success">Frente de Caixa</span>
          <span v-if="pedv.tppedv == 'P'" class="badge" :class="statusColor(pedv.stpedv)">{{ textOption(pedv.stpedv,
              metadata.pedv.stpedv)
          }}</span>
          <span v-if="pedv.tppedv == 'R'" class="badge badge-red">Orçamento Perdido</span>
          <span v-if="pedv.nf_pendente" class="badge badge-red"><strong>Pedido com nota fiscal pendente</strong></span>
          <span v-if="pedv.fin_baixado" class="badge badge-yellow">Pedido com título recebido</span>
          <span v-if="pedv.fin_remessa" class="badge badge-yellow">Título enviado em remessa bancaria</span>
          <span v-if="pedv.status" class="badge badge-blue"> {{ pedv.status }} </span>
          <span v-if="orcamentoVencido" class="badge badge-red mr-2" data-toggle="tooltip" data-placement="top"
            title="Orçamento com data de validade vencida"><i class="fa fa-calendar pr-2" aria-hidden="true"></i>
            Vencido</span>
        </div>
      </div>

      <!-- MENSAGENS DE VALIDACAO -->
      <validation v-if="errmessages" title="Erros de Validação" :messages="errmessages.errmessages"></validation>
      <!-- FIM MENSAGENS DE VALIDACAO -->

      <div v-if="alocacaoPendente">
        <alert type="info" :text="alocacaoPendente"></alert>
      </div>

      <div v-if="alocacaoEfetuada">
        <alert type="info" title="Aviso" :text="alocacaoEfetuada"></alert>
      </div>



      <!-- CAMPOS HABILITADOS PARA INCLUSAO DE REGISTRO -->
      <div v-show="formNew && pedv.codpedv === null">

        <label-title class="nb-margin-bottom" title="Cliente" icon="fa-university"></label-title>

        <div class="row nb-margin-bottom">
          <div class="col-md-6">
            <input-part ref="part" id="part" v-model="pedv.codpart" :add-button="true" name="Cliente"></input-part>
          </div>
        </div>
        <div class="row nb-margin-bottom">
        </div>
        <div class="row">
          <form-field v-model="pedv.seqcontato" type="select2" col="3" :metadata="metadata.pedv.seqcontato"
            :disabled="isView" name="seqcontato" :v-errors="errors" v-validate="metadata.pedv.seqcontato.validator"
            :select2="select2Contato" :add-button="true" @clickAdd="handleIncluirContato()"></form-field>
          <form-field v-model="pedv.tppedv" type="select" col="3" :metadata="local_metadata" :disabled="isView">
          </form-field>
          <form-field v-model="pedv.finalidade" type="select" col="3" :metadata="metadata.pedv.finalidade"></form-field>
          <form-field v-model="pedv.pedcli" type="text" col="3" :metadata="metadata.pedv.pedcli" name="pedcli"
            :v-errors="errors" v-validate="metadata.pedv.pedcli.validator"></form-field>
          <form-field v-model="pedv.codnates" type="select2" col="6" :metadata="metadata.pedv.codnates"
            :disabled="isView" :add-button="true" @clickAdd="handleIncluirNates()" name="codnates" id="codnates"
            :v-errors="errors" v-validate="metadata.pedv.codnates.validator"></form-field>
          <!-- <form-field v-model="pedv.amostra" type="select" col="3" :metadata="metadata.pedv.amostra"></form-field> -->
        </div>
        <div class="row">
          <form-field v-model="pedv.codtabpre" type="select" col="6" :metadata="metadata.pedv.codtabpre"
            :select-options="tabelas_preco_options" name="codtabpre" :v-errors="errors"
            v-validate="metadata.pedv.codtabpre.validator"></form-field>
          <!-- <form-field v-model="pedv.codtabpre" type="select2" col="6" :metadata="metadata.pedv.codtabpre" :disabled="isView"
                        name="codtabpre" :v-errors="errors" v-validate="metadata.pedv.codtabpre.validator"></form-field> -->
        </div>
        <div class="row">
          <form-field v-model="pedv.tpfrete" type="select" col="3" :metadata="metadata.pedv.tpfrete" :disabled="isView">
          </form-field>
          <form-field v-model="pedv.codparttr" type="select2" col="6" :metadata="metadata.pedv.codparttr"
            :disabled="isView" name="codparttr" :v-errors="errors" v-validate="metadata.pedv.codparttr.validator"
            :add-button="true" @clickAdd="handleIncluir('transp')"></form-field>
        </div>
      </div>
      <!-- FIM INCLUSAO -->



      <!-- CAMPOS EXIBIDOS NA EDICAO -->
      <div v-if="pedv.codpedv !== null">
        <label-title title="Cliente" icon="fa-university"></label-title>
        <div class="row col nb-margin-bottom">
          <div class="col-12 col-md-6">
            <input-part ref="part" :disabled="true" v-model="pedv.codpart"></input-part>
          </div>
          <div v-if="pedv.impinfgeraisgarantia" class="col-12 col-md-6">
            <input-switch type="success" label="Imprimir Informações Gerais e Garantia dos Produtos"
              v-model="pedv.impinfgeraisgarantia" value-checked="S" value-unchecked="N"
              @input="updateImpInfGeraisGarantia"></input-switch>
          </div>
        </div>
        <hr>
        <div class="row">
          <div v-if="pedv.dtvalidade" class="col-md-2 col-6">
            <v-label class="w-100" :metadata-field="metadata.pedv.dtvalidade"></v-label>
            <div class="lbl">{{ pedv.dtvalidade | formatData }}</div>
          </div>
          <div v-if="pedv.prazo" class="col-md-2 col-6">
            <v-label class="w-100" :metadata-field="metadata.pedv.prazo"></v-label>
            <div class="lbl">{{ pedv.prazo | formatData }}</div>
          </div>
          <div v-if="pedv.pedcli" class="col-md-2 col-6">
            <v-label class="w-100" :metadata-field="metadata.pedv.pedcli"></v-label>
            <div class="lbl">{{ pedv.pedcli }}</div>
          </div>
          <form-field v-if="!isView && status_customizados_options.length > 0" v-model="pedv.codstatus" type="select"
            col="2" :metadata="metadata.pedv.codstatus" :select-options="status_customizados_options" name="codstatus"
            :v-errors="errors" v-validate="metadata.pedv.codstatus.validator"></form-field>

          <div class="col-md-3 col-4">
            <v-label class="w-100" :metadata-field="metadata.pedv.finalidade"></v-label>
            <div class="lbl">{{ textOption(pedv.finalidade, metadata.pedv.finalidade) }}</div>
          </div>
          <div class="col-md-3 col-4">
            <v-label class="w-100" :metadata-field="metadata.pedv.codnates"></v-label>
            <div class="lbl">{{ pedv.nates.descricao }}</div>
          </div>
          <div class="col-md-3 col-4">
            <v-label class="w-100" :metadata-field="metadata.pedv.tppedv"></v-label>
            <div class="lbl">{{ textOption(pedv.tppedv, metadata.pedv.tppedv) }}</div>
          </div>
        </div>

        <div>
          <label-title v-if="anexos.length > 0" title="Anexos" icon="fa-paperclip"></label-title>
          <anexos-form v-if="anexos.length > 0 || showAnexo" ref="anexos"
            :params="{ ref: 'pedv', chaveref: pedv.codpedv, showForm: false }" @change="handleChangeAnexos">
          </anexos-form>
        </div>

      </div>

    </div>

    <!-- ITENS DO PEDIDO -->
    <div class="default-container nb-margin-top" style="border-top: 3px solid black">

      <div class="" id="produtos">
        <label-title title="Produtos" icon="fa-archive"></label-title>

        <!-- TELA DE PESQUISA DE ITENS PARA INCLUSAO NO PEDIDO -->
        <pedido-addlist v-if="!isView && showPesquisaItens" ref="addList" :params="_paramsPesquisa"
          @closeform="closeFormItem" @additem="handleSalvarItens"></pedido-addlist>
        <!-- FIM TELA DE PESQUISA DE ITENS PARA INCLUSAO NO PEDIDO -->

        <!-- LISTA DE PRODUTOS EM DESTAQUE -->
        <div class="row col mt-2 mb-3">
          <v-button v-if="!isView && possuiListaDestaqueValida" label="Lista de Destaques"
            title="Visualizar lista de produtos em destaque" icon="fa-tags" @click="handleShowDestaque"></v-button>
        </div>
        <pedido-addlist v-if="!isView && showListaDestaques" :params="_paramsDestaques" @closeform="closeDestaque"
          @additem="handleSalvarItens"></pedido-addlist>
        <!-- FIM LISTA DE PRODUTOS EM DESTAQUE -->

        <div v-if="!this.pedv.codnates > 0">
          <alert type="warning" text="Informe a Natureza de Operação para inserir os produtos."></alert>
        </div>
        <div v-else-if="pedvit && pedvit.length == 0">
          <alert type="warning" text="O pedido ainda não possui produtos."></alert>
        </div>
        <div class="mainbox" v-for="(it, index) in pedvit" :key="index">
          <div class="mark-green"></div>
          <div class="box">
            <div class="row">
              <div class="col-md-1 col-2 text-center">
                <img v-if="it.item[0].url" :src="it.item[0].url" class="mx-auto d-block img-thumbnail" alt="Logotipo"
                  style="max-width: 45px; max-height: 45px; cursor: pointer;">
                <i v-else class="fa fa-camera mx-auto d-block" style="font-size: 25px; color: silver"></i>
              </div>
              <div class="col-md-4 col-10">
                <span class="lbl-list-produto w-100">{{ it.item[0].descricao }}</span>
                <v-label label="Codigo"></v-label>
                <span class="lbl">{{ it.item[0].codigo }}</span>
                <v-button v-if="it.pedvgrade && it.pedvgrade.length > 0" title="Exibir grade" icon="fa-th"
                  @click="handleShowGradeItem(index)"></v-button>
                <!-- <span v-if="it.stpedv!='D' && it.stpedv!='F'" class="float-right badge" :class="statusColor(it.stpedv)">{{ textOption(it.stpedv, metadata.pedvit.stpedv) }}</span> -->
                <div class="w-100"></div>
                <span v-if="it.faltaestoque == 'S'" class="error">Produto não possui estoque suficiente.</span>
              </div>
              <div class="col-md-1 col-4">
                <v-label :metadata-field="metadata.pedvit.qtuni"></v-label>
                <span class="lbl">{{ it.qtuni }} {{ it.uni }}</span>
              </div>
              <div class="col-md-1 col-4">
                <v-label label="Preço"></v-label>
                <span class="lbl"><small>R$</small> {{ it.vlr | format(2) }}</span>
              </div>
              <div class="col-md-4 col-4" v-if="it.qt != it.qtuni">
                <v-label :metadata-field="metadata.pedvit.qt"></v-label>
                <span class="lbl">{{ it.qt }}</span>
              </div>
              <div class="col-md-1 col-4">
                <v-label label="Desconto"></v-label>
                <span class="lbl">{{ it.ptotdes | format(2) }}%</span>
              </div>
              <div class="col-md-1 col-4">
                <v-label label="Total"></v-label>
                <span class="lbl"><small>R$</small> {{ it.totger | format(2) }}</span>
              </div>
              <div class="col-md-1 col-4">
                <v-label label="Impostos"></v-label>
                <span class="lbl w-100"><small>IPI</small> {{ it.aipi }}%</span>
                <span class="lbl"><small>ST R$</small> {{ it.vicmst | format(2) }}</span>
              </div>
              <div class="col-md-2 col-12" v-show="it.stpedv == 'D' || it.stpedv == 'P'">
                <bar-grid :options="{ barPedvIt: true, stpedv: it.stpedv, isView: isView }" :moreActions="{}"
                  @edit="handleEditItem(it.itped, false)" @view="handleEditItem(it.itped, true)"
                  @cancel="handleItemCancelMsg(it.itped)" @delete="handleItemDeleteMsg(it.itped)" @action="closeForm()">
                </bar-grid>
              </div>
              <div class="col" v-if="it.showGrade">
                <grade ref="grade"
                  :params="{ view: true, coditem: it.coditem, qt: it.qtuni, listItemGrade: it.pedvgrade }"></grade>
              </div>
            </div>
          </div>
        </div>
        <br>


        <!-- TOTAL DO PEDIDO -->
        <div id="formTotal" v-show="formOrder">
          <!-- <div v-show="pedv.stpedv != 'D'"> -->
          <div v-show="pedvit.length > 0">
            <div class="row">
              <div class="col-md-7 col-12">
              </div>
              <div class="col-md-3 col-6">
                <v-label class="" :metadata-field="metadata.pedv.totmer"></v-label>
                <span class="lbl float-right">R$ {{ pedv.totmer | format(2) }}</span>
                <v-label v-if="pedv.ptotdes > 0" class="" :metadata-field="metadata.pedv.ptotdes"></v-label>
                <span v-if="pedv.ptotdes > 0" class="lbl float-right">{{ pedv.ptotdes | format(2) }}%</span>
                <div class="w-100"></div>
                <v-label v-if="pedv.vlrdesc > 0" class="" :metadata-field="metadata.pedv.vlrdesc"></v-label>
                <span v-if="pedv.vlrdesc > 0" class="lbl float-right">{{ pedv.vlrdesc | format(2) }}</span>
                <v-label class="" :metadata-field="metadata.pedv.rentab"></v-label>
                <span class="lbl float-right">{{ pedv.rentab | format(2) }}%</span>
                <div class="w-100"></div>
                <a class="float-right" style="cursor: pointer; color: #0091ea;" @click="showTotal = true">Detalhar
                  Totais</a>
                <!-- DESTALHES DO TOTAL DO PEDIDO -->
                <div v-if="showTotal" class="dropdown-total align-self-end"
                  style="position: absolute; right: 0; padding: 15px">
                  <button type="button" class="close" @click="showTotal = false"><span
                      aria-hidden="true">&times;</span></button>
                  <div class="row col mb-2">
                  </div>
                  <div class="row">
                    <div class="col">
                      <v-label class="float-left" :metadata-field="metadata.pedv.totmer"></v-label>
                    </div>
                    <div class="col">
                      <span class="lbl float-right">R$ {{ pedv.totmer | format(2) }}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <v-label class="float-left" :metadata-field="metadata.pedv.toticm"></v-label>
                    </div>
                    <div class="col">
                      <span class="lbl float-right">R$ {{ pedv.toticm | format(2) }}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <v-label class="float-left" :metadata-field="metadata.pedv.toticmst"></v-label>
                    </div>
                    <div class="col">
                      <span class="lbl float-right">R$ {{ pedv.toticmst | format(2) }}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <v-label class="float-left" :metadata-field="metadata.pedv.totipi"></v-label>
                    </div>
                    <div class="col">
                      <span class="lbl float-right">R$ {{ pedv.totipi | format(2) }}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <v-label class="float-left" :metadata-field="metadata.pedv.vlrfre"></v-label>
                    </div>
                    <div class="col">
                      <span class="lbl float-right">R$ {{ pedv.vlrfre | format(2) }}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <v-label class="float-left" :metadata-field="metadata.pedv.totdes"></v-label>
                    </div>
                    <div class="col">
                      <span class="lbl float-right">R$ {{ pedv.totdes | format(2) }}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <v-label class="float-left" :metadata-field="metadata.pedv.ptotdes"></v-label>
                    </div>
                    <div class="col">
                      <span class="lbl float-right">R$ {{ pedv.ptotdes | format(2) }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-2 col-12">
                <v-label class="float-right" :metadata-field="metadata.pedv.totger"></v-label><br>
                <span class="lbl-total-documento float-right">R$ {{ pedv.totger | format(2) }}</span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- PARCELAS DO PEDIDO -->
    <div class="default-container nb-margin-top" style="border-top: 3px solid black">
      <div class="nb-margin-top" name="parcelas" id="parcelas">
        <label-title title="Condição de Pagamento" icon="fa-credit-card"></label-title><br>
        <div class="row">
          <form-field ref="parcelas" v-model="pedv.parcelas" type="select" col="2" :metadata="metadata.pedv.parcelas"
            :disabled="isView"></form-field>
          <form-field v-model="pedv.codnatfin" type="select2" col="4" :metadata="metadata.pedv.codnatfin"
            :disabled="isView" :select2="{ entity: 'natfin/receitas/', minlength: 0 }" name="codnatfin"
            :v-errors="errors" v-validate="metadata.pedv.codnatfin.validator"></form-field>
        </div>
        <div class="row mt-3">
          <div class="col-12" v-if="(pedv.parcelas > '0') || (pedvpar && pedvpar.length)">
            <div class="row ">
              <div class="col-md-2 col-3">
                <v-label :metadata-field="metadata.pedvpar.dias"></v-label>
              </div>
              <div class="col-md-2 col-3">
                <v-label :metadata-field="metadata.pedvpar.dtv"></v-label>
              </div>
              <div class="col-md-2 col-3">
                <v-label :metadata-field="metadata.pedvpar.vlr"></v-label>
              </div>
              <div class="col-md-2 col-3">
                <v-label :metadata-field="metadata.pedvpar.obspar"></v-label>
              </div>
              <!-- Forma de Pagamento -->
              <div class="col-md-2 col-3">
                <v-label :metadata-field="metadata.pedvpar.formapag"></v-label>
              </div>
            </div>
            <div class="row " v-for="(par, index) in pedvpar" :key="index">
              <form-field v-model="par.dias" type="number" col="2" :disabled="isView" name="dias" :v-errors="errors"
                v-validate="metadata.pedvpar.dias.validator" @input="pedvparDiasChange(index)"></form-field>
              <form-field v-model="par.dtv" type="date" col="2" :disabled="isView" name="dtv" :v-errors="errors"
                v-validate="metadata.pedvpar.dtv.validator" @input="pedvparDtvChange(index)"></form-field>
              <form-field v-model="par.vlr" type="value" col="2" :precision="2" :disabled="isView" name="vlr"
                :v-errors="errors" v-validate="metadata.pedvpar.vlr.validator" @input="pedvparVlrChange(index)">
              </form-field>
              <form-field v-model="par.obspar" type="text" col="2" :disabled="isView" name="obspar"></form-field>
              <!-- Forma de Pagamento -->
              <form-field v-model="par.formapag" :optionnull="true" type="select" col="3"
                :metadata="metadata.pedvpar.formapag" :disabled="isView" :nolabel="true"></form-field>
            </div>
          </div>
        </div>
        <hr>
      </div>
      <!-- FIM PARCELAS DO PEDIDO -->

      <!--
            <div class="row">
                <form-field v-model="pedv.obsformapag" type="memo" col="6" :metadata="metadata.pedv.obsformapag" :disabled="isView"
                    name="obsformapag" :v-errors="errors" v-validate="metadata.pedv.obsformapag.validator"></form-field>
            </div>
            <div v-if="pedv.tppedv ==='P'">
                <div class="row">
                    <form-field v-model="pedv.obspedido" type="memo" col="6" :metadata="metadata.pedv.obspedido" :disabled="isView"
                        name="obspedido" :v-errors="errors" v-validate="metadata.pedv.obspedido.validator"></form-field>
                    <form-field v-model="pedv.obsnf" type="memo" col="6" :metadata="metadata.pedv.obsnf" :disabled="isView"
                        name="obsnf" :v-errors="errors" v-validate="metadata.pedv.obsnf.validator"></form-field>
                </div>
            </div>
            <div v-if="pedv.tppedv !='P'">
                <div class="row">
                    <form-field v-model="pedv.obscotacao" type="memo" col="6" :metadata="metadata.pedv.obscotacao" :disabled="isView"
                        name="obscotacao" :v-errors="errors" v-validate="metadata.pedv.obscotacao.validator"></form-field>
                </div>
            </div>
-->


      <!-- INFORMACOES COMPLEMENTARES DO PEDIDO -->
      <label-title title="Informações Adicionais" icon="fa-info-circle"></label-title><br>
      <div class="row">
        <div class="col-12">
          <v-button class="mb-3" label="Alterar Informações Adicionais" title="" :nb-btdef="false"
            @click="handleInfAdicionais"></v-button>
        </div>
        <div class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.finalidade"></v-label>
          <div class="lbl">{{ textOption(pedv.finalidade, metadata.pedv.finalidade) }}</div>
        </div>
        <div v-if="pedv.validadedias" class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.validadedias"></v-label>
          <div class="lbl">{{ pedv.validadedias }}</div>
        </div>
        <div v-if="pedv.dtvalidade" class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.dtvalidade"></v-label>
          <div class="lbl">{{ pedv.dtvalidade | formatData }}</div>
        </div>
        <div v-if="pedv.prazodias" class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.prazodias"></v-label>
          <div class="lbl">{{ pedv.prazodias }}</div>
        </div>
        <div v-if="pedv.prazo" class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.prazo"></v-label>
          <div class="lbl">{{ pedv.prazo | formatData }}</div>
        </div>
        <div class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.pedcli"></v-label>
          <div class="lbl">{{ pedv.pedcli }}</div>
        </div>
        <div class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.codtabpre"></v-label>
          <div class="lbl" v-if="pedv.tabpre && pedv.tabpre.length">{{ pedv.tabpre[0].descricao }}</div>
        </div>
        <div class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.tpfrete"></v-label>
          <div class="lbl">{{ textOption(pedv.tpfrete, metadata.pedv.tpfrete) }}</div>
        </div>
        <div class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.codparttr"></v-label>
          <div class="lbl" v-if="pedv.parttr && pedv.parttr.length">{{ pedv.parttr[0].nome }}</div>
        </div>
        <div class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.pliq"></v-label>
          <div class="lbl">{{ pedv.pliq | formatValue(2) }}</div>
        </div>
        <div class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.pbru"></v-label>
          <div class="lbl">{{ pedv.pbru | formatValue(2) }}</div>
        </div>
        <div class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.qtvolumes"></v-label>
          <div class="lbl">{{ pedv.qtvolumes }}</div>
        </div>
        <div class="col-md-4 col-6">
          <v-label class="w-100" :metadata-field="metadata.pedv.seqcontato"></v-label>
          <div class="lbl" v-if="pedv.contato && pedv.contato.length">{{ pedv.contato[0].nomecontato }}</div>
        </div>
        <div class="col-md-12 col-12">
          <v-label class="w-100" :metadata-field="metadata.pedv.enderet"></v-label>
          <div class="lbl">{{ pedv.enderet }} {{ pedv.endenrret }} {{ pedv.bairroret }} {{ pedv.ufret }}</div>
        </div>
        <div class="col-md-12 col-12">
          <v-label class="w-100" :metadata-field="metadata.pedv.endeent"></v-label>
          <div class="lbl">{{ pedv.endeent }} {{ pedv.endenrent }} {{ pedv.bairroent }} {{ pedv.ufent }}</div>
        </div>
      </div>
      <label-title v-if="pedv.historico_status" title="Histório Status" icon="fa-list"></label-title>
      <div class="row" v-if="pedv.historico_status">
        <div class="col-12">
          <ul class="timeline">
            <li>
              <span class="card-text">Pedido Realizado</span><br>
              <span class="card-text">{{ pedv.data | formatDataHoraExtenso }}</span>
            </li>
            <li v-for="(hist, index) in pedv.historico_status" :key="index">
              <span class="card-text">{{ hist.descricao }}</span><br>
              <span class="card-text">{{ hist.data | formatDataHoraExtenso }}</span>
              <p>{{ hist.obs }}</p>
            </li>
          </ul>
        </div>
      </div>


    </div>
    <!-- FIM FORMULARIO PRINCIPAL DO PEDIDO -->


    <!-- BARRA FIXA DE BOTOES INFERIOR -->
    <div class="w-100 text-center" v-show="btTotalizar || pedv.stpedv === 'P'"
      style="position: fixed; left: 0; bottom: 0; z-index: 10; border-top: 1px solid #eee; background-color: #fdfbfb; padding: 15px; -webkit-box-shadow: 0 -2px 5px rgba(0,0,0,0.2); -moz-box-shadow: 0 -2px 5px rgba(0,0,0,0.2); box-shadow: 0 -2px 5px rgba(0,0,0,0.2);">
      <!-- <v-button :disabled="!btTotalizar" tabindex="1" label="Finalizar Digitação de Produtos" title="Efetua a totalização do pedido e encerra a digitação" icon="" @click="handleTotalizar()"></v-button>
                <v-button label="Salvar e Fechar" v-if="!isView" title="" @click="handleTotalizar(true)"></v-button>
                <v-button :disabled="pedv.tppedv != 'O'" v-if="!isView" label="Gerar Pedido" icon="" title="" @click="handleGerarPedido()"></v-button>
                <v-button :disabled="!btImprimir" label="Imprimir" icon="fa-print" @click="handleAction(1)"></v-button>
                <v-button :disabled="!btEnviar" label="Enviar" icon="fa-envelope-open" @click="handleEmail()"></v-button>
                <v-button :disabled="!btFaturar" label="Faturar Pedido" icon="fa-dollar" title="" :nb-btdef="false" @click="handleFaturar()"></v-button> -->

      <v-button v-show="btTotalizar" tabindex="1" label="Finalizar Digitação de Produtos" :nb-btdef="true"
        title="Efetua a totalização do pedido e encerra a digitação" icon="" @click="handleTotalizar()"></v-button>
      <div v-show="pedv.stpedv === 'P'">
        <v-button v-if="botaoGerarPedido" label="Gerar Pedido" icon="" title="" :nb-btdef="true"
          @click="handleGerarPedido()"></v-button>
        <v-button label="Salvar e Fechar" v-if="!isView" title="" :nb-btdef="true" @click="handleTotalizar(true)">
        </v-button>
        <v-button label="Imprimir" icon="fa-print" v-show="btImprimir" :nb-btdef="false" @click="handleAction(1)">
        </v-button>
        <v-button label="Enviar Email" icon="fa-envelope-open" v-show="btEnviar" :nb-btdef="false"
          @click="handleEmail()"></v-button>
        <v-button v-if="botaoPerdido" label="Orçamento Perdido" icon="" title="" :danger="true"
          @click="handleOrcamentoPedido()"></v-button>
        <v-button v-if="botaoAlocarProdutos" label="Alocar Produtos" title="" icon="" @click="handleAlocacao">
        </v-button>
        <v-button v-show="btFaturar" label="Emitir NF-e" title="" :success="true" @click="handleFaturar('NFE')">
        </v-button>
        <v-button v-show="btFaturar" label="Emitir NFC-e" title="" :success="true" @click="handleFaturar('NFCe')">
        </v-button>
      </div>

    </div>
    <!-- FIM BARRA FIXA DE BOTOES INFERIOR -->


    <!-- ALOCACAO DO PEDIDO -->
    <div class="nb-modal-scrollable" v-if="showFormAlocacao">
      <div class="nb-modal-scrollable-container" style="padding: 15px; width: 90%">
        <div class="nb-modal-scrollable-body">
          <estoque-saida :index="pedv.codpedv" :excluir="excluirAlocacao" :pedido="true" @closeform="closeAlocacaoForm">
          </estoque-saida>
        </div>
      </div>
    </div>


    <div class="default-container mt-2" style="border-top: 3px solid black" v-if="showTitulosPedido">
      <!-- TITULOS A RECEBER -->
      <pedido-titulos :fin-list="pedv.fin"></pedido-titulos>
    </div>


    <!-- MENSAGEM PARA CANCELAR ITEM DO PEDIDO -->
    <md-message v-if="CANCEL_ITEM_MESSAGE" code="cancelit" @close="handleCloseMessage()" @confirm="handleItemCancel()">
    </md-message>

    <!-- MENSAGEM PARA REMOVER ITEM DO PEDIDO -->
    <md-message v-if="DELETE_ITEM_MESSAGE" code="deleteit" @close="handleCloseMessage()" @confirm="handleItemDelete()">
    </md-message>

    <!-- MENSAGEM PARA CANCELAMENTO DO PEDIDO -->
    <md-message v-if="CANCEL_MESSAGE" code="cancelpedv" @close="handleCloseMessage()" @confirm="handleCancel()">
    </md-message>


    <!-- TELA MODAL DE INCLUSAO/ALTERACAO DE ITEM DO PEDIDO -->
    <div v-if="showFormItem">
      <Trap>
        <pedido-additem :params="{ pedv: pedv, pedvit: pedvit_update }" :view="formItemView" @closeform="closeFormItem"
          @save="handleSalvarItens"></pedido-additem>
      </Trap>
    </div>
    <!-- FIM TELA MODAL DE INCLUSAO/ALTERACAO DE ITEM DO PEDIDO -->

    <!-- TELA MODAL DE INFORMACOES COMPLEMENTARES -->
    <div v-if="showFormInfAd">
      <Trap>
        <pedido-form-infcpl :controleEstoqueAtivado="controleEstoqueAtivado" :is-view="isView" :metadata="metadata"
          :pedv="pedv" :partCodTabpre="partCodTabpre" @closeform="closeFormItem" @save="handleSaveCab">
        </pedido-form-infcpl>
      </Trap>
    </div>
    <!-- FIM TELA MODAL DE INFORMACOES COMPLEMENTARES -->


    <!-- CADASTRO DO CONTATO -->
    <div v-if="showContatoForm">
      <Trap>
        <customer-contato-form crud="ins" :codpart="pedv.codpart" @closeform="closeContatoForm"></customer-contato-form>
      </Trap>
    </div>
    <!-- FIM CADASTRO DO CONTATO -->

    <!-- CADASTRO DE PARTICIPANTE -->
    <div class="nb-modal-scrollable" v-if="showPartForm">
      <Trap>
        <div class="container nb-modal-scrollable-container">
          <div class="nb-modal-scrollable-body">
            <customer-form crud="ins" @closeform="closePartForm"></customer-form>
          </div>
        </div>
      </Trap>
    </div>
    <!-- FIM CADASTRO DE PARTICIPANTE -->

    <!-- CADASTRO DE NATUREZA -->
    <div class="nb-modal-scrollable" v-if="showNatesForm">
      <Trap>
        <div class="container nb-modal-scrollable-container">
          <div class="nb-modal-scrollable-body">
            <nates-form crud="ins" @closeform="closeNatesForm"></nates-form>
          </div>
        </div>
      </Trap>
    </div>
    <!-- FIM CADASTRO DE NATUREZA -->

    <!-- ENVIO DE EMAIL -->
    <div v-if="showFormEmail">
      <Trap>
        <email-form :index="pedv.codpedv" tipo="PEDV" title="Envio de Pedido" @closeform="closeFormEmail"
          @send="handleSendEmail"></email-form>
      </Trap>
    </div>
    <!-- FIM ENVIO DE EMAIL -->

    <div style="display: none">
      <PedidoImpressao ref="impressao" v-if="showImpressao" :index="codpedvImpressao" @close="handleClosePrint" />
    </div>

  </div>
</template>

<style scoped>
.dropdown-total {
  z-index: 1051;
  margin-top: 3px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  position: absolute;
  padding: 10px;
  z-index: 1000;
  float: left;
  min-width: 160px;
  list-style: none;
  background-color: #fff;
  border: 1px solid #00000033;
  box-shadow: 0 5px 10px #00000033;
  background-clip: padding-box;
}
</style>



// WEBPACK FOOTER //
// src/forms/pedido-form.vue